// Simple bilingual dictionary. Default language: English.
export const dict = {
    en: {
        nav: {
            services: "Services",
            manifesto: "The House",
            occasions: "Occasions",
            gallery: "Gallery",
            availability: "Availability",
            testimonials: "Love notes",
            contact: "Contact",
            admin: "Admin",
            call: "Call",
        },
        hero: {
            scroll: "Scroll to unwrap",
            since: "Family-run since 2018",
            call: "Call (854) 252-4440",
            whatsapp: "WhatsApp",
            openStudio: "Family Party Atelier",
            addressLabel: "Studio",
        },
        marquee: [
            "Custom piñatas",
            "Bounce houses",
            "Tables & chairs",
            "Backdrop walls",
            "Candy tables",
            "Water bottle stickers",
            "Decorated lollipops",
            "Centerpieces",
            "Handcrafted favors",
        ],
        manifesto: {
            eyebrow: "The house",
            title: "A small studio on the Grand Strand,\nbuilt around one idea:",
            statement: "no celebration is too small to be styled with love.",
            chapters: [
                {
                    number: "01",
                    title: "Piñatas as heirlooms",
                    body: "Every piñata is built by hand around the character your child asked for. Cut, glued, papered, dressed — never mass-produced. When the last candy falls, most families keep the head.",
                },
                {
                    number: "02",
                    title: "Rentals you don't have to fuss over",
                    body: "Jumpers arrive early, wiped down and set up. Tables and chairs are counted twice. The moment the party ends, we come back so you can breathe.",
                },
                {
                    number: "03",
                    title: "Bilingual, familia-first",
                    body: "We take orders in Spanish and in English. We know the difference between a baby shower and a bautizo. And we treat both like the once-in-a-lifetime days they are.",
                },
            ],
        },
        catalogue: {
            eyebrow: "The catalogue",
            title: "Everything you need for the day.",
            desc: "From custom piñatas to bounce houses and party favors — one studio, one phone call.",
        },
        occasions: {
            eyebrow: "We cater to",
            title: "Occasions",
            list: [
                { key: "birthdays", en: "Birthdays", es: "Cumpleaños" },
                { key: "baptisms", en: "Baptisms", es: "Bautizos" },
                { key: "babyshower", en: "Baby showers", es: "Baby Showers" },
                { key: "anniversary", en: "Anniversaries", es: "Aniversarios" },
                { key: "grads", en: "Graduations", es: "Graduaciones" },
                { key: "quince", en: "Quinceañeras", es: "Quinceañeras" },
            ],
        },
        gallery: {
            eyebrow: "The archive",
            title: "Real parties.\nReal families.",
            desc: "A living notebook of piñatas, candy boxes and backdrop walls we've built for Myrtle Beach families.",
            next: "Next",
            prev: "Previous",
            close: "Close",
        },
        availability: {
            eyebrow: "Check availability",
            title: "Reserve your jumper\nin under a minute.",
            desc: "Pick a bounce house, choose the day of your party, leave your number — no phone tag.",
            selectJumper: "Choose a bounce house",
            selectDate: "Choose the date",
            dateHint: "Booked dates are shown in pink and can't be picked.",
            legendAvailable: "Available",
            legendBooked: "Booked",
            legendSelected: "Selected",
            form: {
                name: "Your name",
                phone: "Phone",
                email: "Email (optional)",
                occasion: "Occasion",
                start: "Start time",
                end: "End time",
                message: "Anything Karina should know?",
                submit: "Request this date",
                submitting: "Reserving…",
                pickFirst: "Pick a jumper and a date first.",
                success: "Reservation requested — Karina will call to confirm.",
                conflict: "That date is no longer available. Please pick another.",
                error: "Something didn't send. Please try again or call us.",
                required: "Add your name, phone, and message.",
            },
        },
        testimonials: {
            eyebrow: "Love notes",
            title: "Words from our families",
        },
        contact: {
            eyebrow: "Say hello",
            title: "Let's plan\nthe next one.",
            desc: "Tell us the theme, the age, the vibe — we'll build the rest around you.",
            phone: "Call the studio",
            whatsapp: "WhatsApp",
            location: "Studio",
            form: {
                name: "Your name",
                email: "Email (optional)",
                phone: "Phone",
                occasion: "Occasion",
                message: "Tell us about the party",
                submit: "Send message",
                submitting: "Sending…",
                success: "Message sent — Karina will be in touch shortly.",
                error: "Something didn't send. Please try again or call us.",
                required: "Please fill out your name and message.",
            },
        },
        footer: {
            hours: "By appointment · 7 days a week",
            copy: "© 2026 Piñatas con Karina & Jump & Jump Rental Services LLC.",
            admin: "Admin",
        },
    },
    es: {
        nav: {
            services: "Servicios",
            manifesto: "La Casa",
            occasions: "Ocasiones",
            gallery: "Galería",
            availability: "Disponibilidad",
            testimonials: "Cariñitos",
            contact: "Contacto",
            admin: "Admin",
            call: "Llamar",
        },
        hero: {
            scroll: "Desliza para desempacar",
            since: "Familia · desde 2018",
            call: "Llama (854) 252-4440",
            whatsapp: "WhatsApp",
            openStudio: "Atelier familiar de fiestas",
            addressLabel: "Estudio",
        },
        marquee: [
            "Piñatas personalizadas",
            "Renta de jumpers",
            "Mesas y sillas",
            "Muros decorativos",
            "Mesa de dulces",
            "Stickers para botellas",
            "Paletas decoradas",
            "Centros de mesa",
            "Recuerditos hechos a mano",
        ],
        manifesto: {
            eyebrow: "La casa",
            title: "Un pequeño estudio en la Grand Strand,\nconstruido sobre una idea:",
            statement: "ninguna celebración es demasiado pequeña para hacerse con amor.",
            chapters: [
                {
                    number: "01",
                    title: "Piñatas que se guardan",
                    body: "Cada piñata se hace a mano alrededor del personaje que pidió tu hijo. Cortada, pegada, empapelada y vestida — nunca en línea de producción. Cuando cae el último dulce, muchas familias guardan la cabeza.",
                },
                {
                    number: "02",
                    title: "Rentas sin preocupaciones",
                    body: "Los jumpers llegan temprano, limpios y armados. Las mesas y sillas se cuentan dos veces. En cuanto termina la fiesta, regresamos para que tú puedas descansar.",
                },
                {
                    number: "03",
                    title: "Bilingüe y de familia",
                    body: "Atendemos en español y en inglés. Sabemos la diferencia entre un baby shower y un bautizo. Y tratamos ambos como los días irrepetibles que son.",
                },
            ],
        },
        catalogue: {
            eyebrow: "El catálogo",
            title: "Todo lo que necesitas para el día.",
            desc: "Desde piñatas personalizadas hasta jumpers y recuerditos — un solo estudio, una sola llamada.",
        },
        occasions: {
            eyebrow: "Atendemos",
            title: "Ocasiones",
            list: [
                { key: "birthdays", en: "Birthdays", es: "Cumpleaños" },
                { key: "baptisms", en: "Baptisms", es: "Bautizos" },
                { key: "babyshower", en: "Baby showers", es: "Baby Showers" },
                { key: "anniversary", en: "Anniversaries", es: "Aniversarios" },
                { key: "grads", en: "Graduations", es: "Graduaciones" },
                { key: "quince", en: "Quinceañeras", es: "Quinceañeras" },
            ],
        },
        gallery: {
            eyebrow: "El archivo",
            title: "Fiestas reales.\nFamilias reales.",
            desc: "Un cuaderno vivo de piñatas, cajitas y muros decorativos que hemos hecho para familias de Myrtle Beach.",
            next: "Siguiente",
            prev: "Anterior",
            close: "Cerrar",
        },
        availability: {
            eyebrow: "Consulta disponibilidad",
            title: "Aparta tu jumper\nen menos de un minuto.",
            desc: "Elige un brincolín, escoge el día de tu fiesta y déjanos tu número — sin llamadas de ida y vuelta.",
            selectJumper: "Elige un brincolín",
            selectDate: "Elige la fecha",
            dateHint: "Las fechas rosas ya están apartadas y no se pueden elegir.",
            legendAvailable: "Disponible",
            legendBooked: "Reservada",
            legendSelected: "Seleccionada",
            form: {
                name: "Tu nombre",
                phone: "Teléfono",
                email: "Correo (opcional)",
                occasion: "Ocasión",
                start: "Hora de inicio",
                end: "Hora de fin",
                message: "¿Algo que Karina deba saber?",
                submit: "Reservar esta fecha",
                submitting: "Reservando…",
                pickFirst: "Primero elige un jumper y una fecha.",
                success: "¡Solicitud enviada! Karina te llamará para confirmar.",
                conflict: "Esa fecha ya no está disponible. Elige otra por favor.",
                error: "Algo no salió bien. Inténtalo otra vez o llámanos.",
                required: "Agrega tu nombre, teléfono y mensaje.",
            },
        },
        testimonials: {
            eyebrow: "Cariñitos",
            title: "Palabras de nuestras familias",
        },
        contact: {
            eyebrow: "Salúdanos",
            title: "Planeemos\nla siguiente.",
            desc: "Cuéntanos la temática, la edad, el ambiente — nosotros construimos lo demás alrededor de ti.",
            phone: "Llama al estudio",
            whatsapp: "WhatsApp",
            location: "Estudio",
            form: {
                name: "Tu nombre",
                email: "Correo (opcional)",
                phone: "Teléfono",
                occasion: "Ocasión",
                message: "Cuéntanos sobre la fiesta",
                submit: "Enviar mensaje",
                submitting: "Enviando…",
                success: "Mensaje enviado — Karina te contactará muy pronto.",
                error: "Algo no salió bien. Inténtalo otra vez o llámanos.",
                required: "Por favor completa tu nombre y mensaje.",
            },
        },
        footer: {
            hours: "Con cita · 7 días a la semana",
            copy: "© 2026 Piñatas con Karina & Jump & Jump Rental Services LLC.",
            admin: "Admin",
        },
    },
};

export const useT = (lang) => (path) => {
    const parts = path.split(".");
    let node = dict[lang] || dict.en;
    for (const p of parts) {
        if (node && Object.prototype.hasOwnProperty.call(node, p)) node = node[p];
        else return path;
    }
    return node;
};
